<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1>Analytics</h1>
      </div>
      <div class="row">
        <b-form inline class="ml-4">&nbsp;</b-form>
      </div>
    </div>

    <div class="container-fluid" v-show="dashboardLoaded && dashboardUrl.length > 0">
      <div class="row analytics-header">
        <div id="dashboardContainer" class="col-12"></div>
      </div>
    </div>

    <div class="alert alert-secondary" role="alert" v-show="!dashboardLoaded && !dashboardUrl.length">
      &nbsp;&nbsp;Analytics is not enabled for this clinic.
    </div>

    <loading-modal :visible="showLoadingModal" @update:visible="visible => showLoadingModal = visible"></loading-modal>
  </div>
</template>

<script>
  import api from '../services/api'
  import LoadingModal from '../components/LoadingModal'
  import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk'

  export default {
    name: 'Analytics',

    components: { LoadingModal },

    computed: {},

    created () {
      this.$store.$on('organization:changed', this.handleOrgChange)
      this.$store.$on('user:authenticated', this.handleLogin)

      if (this.$store.isAuthenticated) {
        this.load()
      }
    },

    data () {
      return {
        autoRefreshEnabled: true,
        dashboardLoaded: false,
        dashboardUrl: '',
        errors: [],
        isLoading: false,
        showLoadingModal: false
      }
    },

    methods: {
      embedDashboard (dashboardUrl) {
        const containerDiv = document.getElementById('dashboardContainer')
        const params = {
          url: dashboardUrl,
          container: containerDiv,
          height: '1500px'
        }
        // console.log(params)

        const dashboard = QuickSightEmbedding.embedDashboard(params)
        // console.log(dashboard)

        dashboard.on('error', this.handleDashboardError)

        dashboard.on('load', this.handleDashboardLoad)
      },

      handleDashboardError () {
        const div = document.getElementById('errorContainer')
        div.innerHTML = 'Your seesion has expired.'
      },

      handleDashboardLoad () {
        // Do nothing.
      },

      handleLogin () {
        this.load()
      },

      handleOrgChange (newOrg, event) {
        this.load()
      },

      load (silent = false) {
        if (!silent) {
          this.showLoadingModal = true
        }

        if (this.isLoading) {
          return
        }

        this.errors = []
        this.isLoading = true
        this.dashboardLoaded = false

        api
          .get('/Dashboard/QuickSightPaymentDashboard')
          .then((response) => {
            this.isLoading = false

            if (response.data.pass) {
              this.dashboardUrl = response.data.url
              this.embedDashboard(this.dashboardUrl)
              console.log(this.dashboardUrl)
              this.dashboardLoaded = true
            }

            // if (this.autoRefreshEnabled) {
            //   setTimeout(this.refreshDashboard, 10000)
            // }
          })
          .catch((error) => {
            this.isLoading = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.$log.error(
                'Error attempting to load dashboard: ' + error.message,
                error
              )
              this.errors = ['Error loading dashboard: ' + error.message]
            }
          })
          .then(() => {
            // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
            setTimeout(() => {
              this.showLoadingModal = false
            }, 100)
          })
      },

      refreshDashboard () {
        if (this.autoRefreshEnabled) {
          this.load(true)
        }
      }
    },

    mounted () {
      const awsEmbeddingScript = document.createElement('script')
      awsEmbeddingScript.setAttribute(
        'src',
        'https://unpkg.com/amazon-quicksight-embedding-sdk@1.0.2/dist/quicksight-embedding-js-sdk.min.js'
      )
      document.head.appendChild(awsEmbeddingScript)
      const awsScript = document.createElement('script')
      awsScript.setAttribute(
        'src',
        'https://sdk.amazonaws.com/js/aws-sdk-2.517.0.min.js'
      )
      document.head.appendChild(awsScript)
    },

    update () {}
  }
</script>

<style scoped>
  .header div h1 {
    color: rgb(255, 70, 0);
    font-weight: lighter;
    font-size: 28px;
    margin: 0;
  }

  .header > h5 {
    margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
  }

  .analytics-header div {
    padding: 0.75rem;
    vertical-align: bottom;
    border-top: 1px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    font-weight: bold;
    border-collapse: collapse;
  }

  .analytics-row .column {
    padding: 0.75rem;
    vertical-align: bottom;
    border-collapse: collapse;
  }

  .analytic-row {
    border-bottom: 1px solid #dee2e6;
    background-color: #f9f9f9;
    /*cursor: pointer;*/
  }
</style>
